export const ALPHA_PAGE_OVERVIEW = "Overview"
export const ALPHA_PAGE_BEST_SELLERS = "Best sellers"
export const ALPHA_PAGE_RANGE_REVIEW = "Range review"
export const ALPHA_PAGE_CHANNEL = "Channel"
export const ALPHA_PAGE_PRODUCT_LINE = "Product line"
export const ALPHA_PAGE_PRODUCT = "Product"
export const ALPHA_PAGE_PRODUCTS = "Products"
export const ALPHA_PAGE_CHANNELS = "Channels"
export const ALPHA_MANAGE_DATA = "Manage data"

// Temporary Page to show blocks
export const ALPHA_PAGE_BLOCKS = "Blocks"
export const ALPHA_PAGE_SEGMENTATION = "Product Segmentation"
export const ALPHA_PAGE_ABC = "Product ABC"
export const ALPHA_FORMULA_MISSING_VALUES = "Missing Values"
